import React, { useState } from "react";
import "./styles.css";
import { Grid, Typography, TextField, Link } from "@mui/material";
import DialogComp from "../../components/Dialog-Popup";
import Button from "../../components/Button";
import loginimage from "../../assets/lg2.jpg";
import image1 from "../../assets/loginmiddle2.png";
import image2 from "../../assets/logindotted.png";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [popuptitle, SetPopupTitle] = useState("");
  const [popupContent, SetPopupContent] = useState("");
  const [buttonArr, setButtonArr] = useState([]);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await fetch("https://usermanagementsystem-497524552274.us-central1.run.app/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("token", data.token);
        setOpenPopup(true);
        SetPopupTitle("Logged in successfully");
        SetPopupContent("You've successfully logged in.");
        setButtonArr([{ id: "1", value: "PROCEED", color: "borderLess", fontSize: "16px", functionCall: () => navigate("/Job") }]);
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <Grid
      container
      className="login_container"
      style={{
        backgroundImage: `url(${loginimage})`,
        height: "100vh",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={10}
        sm={6}
        md={4}
        sx={{
          background: "rgba(255, 255, 255, 0.9)",
          padding: "2rem",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "600", color: "#0D5C75", marginBottom: "1rem" }}>
          Login to continue
        </Typography>

        <TextField
          label="Email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          size="small"
          margin="dense"
          InputLabelProps={{ style: { color: "#0D5C75", fontSize: "95%" } }}
        />

        <TextField
          label="Password"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          size="small"
          margin="dense"
          InputLabelProps={{ style: { color: "#0D5C75", fontSize: "95%" } }}
        />

        {error && <Typography sx={{ color: "red", fontSize: "0.9rem", marginTop: "0.5rem" }}>{error}</Typography>}

        <Button color="green" name="Login" onClick={handleLogin} style={{ marginTop: "1rem", width: "100%" }} />
      </Grid>

      <DialogComp openPopup={openPopup} popuptitle={popuptitle} popupContent={popupContent} buttonValue={buttonArr} />
    </Grid>
  );
}

export default Login;
